import { motion } from "framer-motion";
import { MapPin, Phone, Smartphone, Mail, MessageCircle, Clock } from "lucide-react";
import { SEDI, CONTACTS, waLink } from "@/data/site";

export const Locations = () => {
  return (
    <section id="sedi" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.3em] text-gold-500 font-sans mb-5">
              Dove siamo
            </h4>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-white leading-tight">
              Tre sedi
              <br />
              <span className="italic text-gray-400">tra Ferrara e Rovigo.</span>
            </h2>
            <p className="mt-6 text-gray-400">
              Scegli la sede più comoda: ti aiutiamo noi a trovare quella giusta in
              base allo strumento e agli orari.
            </p>

            <div className="mt-8 space-y-3">
              {CONTACTS.phones.map((p) => (
                <a
                  key={p.link}
                  data-testid={`contact-phone-${p.link}`}
                  href={`tel:${p.link}`}
                  className="flex items-center gap-3 text-gray-300 hover:text-gold-500 transition-colors duration-200"
                >
                  <Phone size={18} className="text-gold-500 shrink-0" />
                  <span>
                    {p.display}
                    <span className="text-gray-500 text-sm"> · {p.label}</span>
                  </span>
                </a>
              ))}
              {CONTACTS.mobiles.map((m) => (
                <a
                  key={m.link}
                  data-testid={`contact-mobile-${m.link}`}
                  href={`tel:${m.link}`}
                  className="flex items-center gap-3 text-gray-300 hover:text-gold-500 transition-colors duration-200"
                >
                  <Smartphone size={18} className="text-gold-500 shrink-0" />
                  {m.display}
                </a>
              ))}
              <a
                data-testid="contact-email"
                href={`mailto:${CONTACTS.email}`}
                className="flex items-center gap-3 text-gray-300 hover:text-gold-500 transition-colors duration-200"
              >
                <Mail size={18} className="text-gold-500 shrink-0" /> {CONTACTS.email}
              </a>
              <p className="flex items-center gap-3 text-gray-400 text-sm pt-1">
                <Clock size={18} className="text-gold-500 shrink-0" /> {CONTACTS.orari}
              </p>
              <a
                data-testid="contact-whatsapp"
                href={waLink("Ciao, vorrei informazioni sulle sedi e le preiscrizioni 2026/2027")}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white font-medium px-6 py-3 mt-2 hover:-translate-y-0.5 transition-transform duration-200"
              >
                <MessageCircle size={18} /> Scrivici su WhatsApp
              </a>
            </div>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-3 gap-5">
            {SEDI.map((s, i) => (
              <motion.div
                key={s.name}
                data-testid={`sede-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="rounded-2xl border border-white/10 bg-ink-800 p-7 hover:border-gold-500/50 transition-colors duration-300"
              >
                <MapPin size={22} className="text-gold-500" />
                <h3 className="mt-5 font-serif text-2xl text-white">{s.name}</h3>
                <p className="mt-1 text-sm text-gray-400">{s.detail}</p>
                <p className="mt-4 text-xs uppercase tracking-wider text-gold-500/80">
                  {s.tag}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
